<template>
  <div class="main" v-bind:class="{ setMarker: setState }">

    <loader v-if="!dataLoaded"></loader>

    <l-map class="mainMap" ref="map" :zoom.sync="zoom" :options="mapOptions" :center="center" :minZoom="minZoom" :maxZoom="maxZoom" @click="mapClick" :crs="crs">

      <l-image-overlay :url="url" :bounds="[[0, 0], [1000, 1000]]"></l-image-overlay>

      <l-area v-for="area in filteredAreas"
        @area-update="onAreaUpdate($event, area)"

        :transformable="areaTransformable(area['.key'])"
        :fill-opacity="areaFillOpacity(area['.key'])"
        :lat-lng="area.latLng"
        :title="area.title"
        :internal="area.internal"
        :size="area.size"
        :circle="area.circle"
        :class-name="area['.key']"
        :opacity="1"
        v-bind:key="area['.key']"
      >
      </l-area>
      <v-marker-cluster ref="clusterRef">
        <l-marker v-for="post in filteredPosts"

          v-if="post['board'] == board"
          @click="markerOpen(post)"

          :visible="markerVisible(post)"
          :options="markerOptions"
          :title="post.title"
          :icon="markerIcon(post)"
          :lat-lng="post.position"
          v-bind:key="post.key"
        >
          <l-tooltip v-if="dataLoaded" :class-name="toolTipClassName(post)" :content="post.title" :options="toolTipOptions(post)" />
          <!-- <l-popup :content="'Vorschau des Beitrags'" :options="popupOptions"  /> -->
        </l-marker>
      </v-marker-cluster>

      <l-marker v-if="boardData.sync && !share && boardData.cursor"
        :visible="true"
        :draggable="false"
        :options="{ riseOnHover: true, className: 'presenter' }"
        :title="boardData.user"
        :icon="cursorIcon"
        :lat-lng="boardData.cursor"
      >
        <l-tooltip v-if="dataLoaded" :content="boardData.user" :options="cursorOptions" />
      </l-marker>

      <l-mini-map v-if="dataLoaded" :posts="filteredPosts" :areas="filteredAreas"></l-mini-map>

    </l-map>

    <add-to-project-hint @closeSelectionMap="$emit('closeSelectionMap')"></add-to-project-hint>
    <map-filter-box v-if="!markerSelected && dataLoaded && !createNewModal && !setNewData" @toggleHistory="toogleHistoryMode()" @searchComplete="searchComplete($event)" :items="filteredPosts" :type="filterType" :project="filterProject" :priority="filterPriority" :tag="filterTag"  :history="historyMode" @setFilter="setFilter($event)"></map-filter-box>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import L from 'leaflet' // braucht man das hier für vue2-leaflet?
import { LMap, LPopup, LMarker, LImageOverlay } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
// import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import LArea from '@/components/LArea' // eslint-disable-line
import LTooltip from '@/components/LTooltip' // eslint-disable-line
import LMiniMap from '@/components/LMiniMap' // eslint-disable-line
import MapFilterBox from '@/components/MapFilterBox' // eslint-disable-line
import AddToProjectHint from '@/components/AddToProjectHint' // eslint-disable-line
import Loader from '@/components/Loader' // eslint-disable-line
import moment from 'moment'
import cuid from 'cuid'
import _ from 'lodash'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster' // eslint-disable-line

var db = firebase.database()

var areasRef = db.ref('areas')
var postsRef = db.ref('posts')
var boardsRef = db.ref('boards')
var iconsRef = db.ref('icons')

var uuid = cuid()

export default {
  name: 'Map',
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    LTooltip,
    LArea,
    LMiniMap,
    MapFilterBox,
    AddToProjectHint,
    Loader,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  data () {
    return {
      board: 'development',
      msg: 'Das ist die Default Nachricht!',
      // center: L.latLng(49.1593467, 10.5537924),
      center: L.latLng(500, 500),
      share: false,
      url: require('@/assets/mapBg.svg'),
      minZoom: -100,
      maxZoom: 10,
      miniMapZoomLevel: 3,
      dataLoaded: false,
      zoom: 0,
      attribution: '',
      crs: L.CRS.Simple,
      setState: false,
      activeMarker: null,
      markerDrag: false,
      markerTitleFilter: null,
      markerSelected: null,
      jump: false,
      areaSelected: null,
      currentUser: firebase.auth().currentUser,
      session: uuid,
      createNewModal: false,
      setNewData: false,
      sidebarSetting: 'min',
      historyMode: false,
      historyDate: false,
      fullscreen: false,
      sidebarSettingBefore: null,
      filterPriority: false,
      filterProject: false,
      filterTag: false,
      filterType: false,
      markerOptions: {
        riseOnHover: true
      },
      mapOptions: {
        zoomControl: false
      },
      popupOptions: {
        offset: new L.Point(0, 0)
      },
      cursorIcon: new L.Icon({
        iconUrl: require('@/assets/icons/cursor.png'),
        iconSize: [48, 48],
        className: 'presenterIcon'
      }),
      cursorOptions: {
        permanent: true,
        direction: 'right',
        interactive: true,
        className: 'presenterCursor'
      }
    }
  },
  methods: {
    areaTransformable: function (key) {
      if (this.areaSelected != null) {
        if (key === this.areaSelected['.key']) {
          return true
        }
      }
      return false
    },
    areaFillOpacity: function (key) {
      if (this.areaSelected == null) {
        return 0
      } else {
        if (key === this.areaSelected['.key']) {
          return 0.2
        } else {
          return 0
        }
      }
    },
    updateMarker: function (post) {
      postsRef.child(post['.key']).child('title').set(post.title)
      postsRef.child(post['.key']).child('icon').set(post.icon)
      postsRef.child(post['.key']).child('priority').set(post.priority)
      if (post.link) {
        postsRef.child(post['.key']).child('link').set(post.link)
      }
      postsRef.child(post['.key']).child('modified').set(moment().format())
    },
    updateArea: function (area) {
      areasRef.child(area['.key']).child('title').set(area.title)
    },
    deleteMarker: function (post) {
      postsRef.child(post['.key']).remove()
    },
    markerIcon: function (post) {
      var icon = post.icon
      var active = false
      if (this.markerSelected) {
        if (post['.key'] === this.markerSelected['.key']) {
          active = true
        }
      }
      // if (!this.filteredPosts.includes(post)) {
      //   return L.icon({
      //     iconUrl: require('@/assets/icons/' + icon + '_filtered.png'),
      //     iconSize: [16, 16]
      //   })
      // }
      if (active) {
        return L.icon({
          iconUrl: require('@/assets/icons/move.png'),
          iconSize: [18, 18]
        })
      } else {
        if (post.priority === '2') {
          return L.icon({
            iconUrl: require('@/assets/icons/' + icon + '_2.png'),
            iconSize: [18, 18]
          })
        }
        if (post.priority === '1') {
          return L.icon({
            iconUrl: require('@/assets/icons/' + icon + '_1.png'),
            iconSize: [18, 18]
          })
        }
        return L.icon({
          iconUrl: require('@/assets/icons/' + icon + '.png'),
          iconSize: [18, 18]
        })
      }
    },
    markerVisible: function (post) {
      if (!this.markerTitleFilter) { return true }
      if (!post.title) { return false }
      let title = post.title
      if (title.includes(this.markerTitleFilter)) { return true }
      return false
    },
    setFilter: function (event) {
      this.filterProject = event.project
      this.filterPriority = event.priority
      this.filterTag = event.tag
      this.filterType = event.type
    },
    mapClick: function (event) {
    },
    markerOpen: function (post) {
      this.$emit('selected', post['.key'])
    },
    onAreaUpdate (event, area) {
      areasRef.child(area['.key']).child('latLng').set(event.latLng)
      areasRef.child(area['.key']).child('size').set(event.size)
    },
    toolTipOptions (post) {
      var add = ''
      if (this.markerSelected) {
        if (post['.key'] === this.markerSelected['.key']) {
          add = 'tooltip--selected'
        }
      }

      // console.log(post)

      if (post.priority) {
        if (post.priority === '2') {
          add = add + ' tooltip--prio2'
        }
        if (post.priority === '1') {
          add = add + ' tooltip--prio1'
        }
      }

      // if (!this.filteredPosts.includes(post)) {
      //   add = add + ' tooltip--filtered'
      // }

      if (post.link || post.content) {
        if (post.link) {
          return {
            permanent: true,
            direction: 'right',
            interactive: true,
            className: 'tooltip--clickable tooltip--link ' + add
          }
        } else {
          return {
            permanent: true,
            direction: 'right',
            interactive: true,
            className: 'tooltip--clickable ' + add
          }
        }
      } else {
        return {
          permanent: true,
          direction: 'right',
          interactive: true,
          className: add
        }
      }
    },
    toolTipClassName (post) {
      var add = ''
      // if (!this.filteredPosts.includes(post)) {
      //   add = add + ' tooltip--filtered'
      // }
      if (this.markerSelected) {
        if (post['.key'] === this.markerSelected['.key']) {
          add = add + ' tooltip--selected'
        }
      }
      if (post.priority === '2') {
        add = add + ' tooltip--prio2'
      }
      if (post.priority === '1') {
        add = add + ' tooltip--prio1'
      }
      return add
    },
    setSidebar (value) {
      // if (setSidebar)
      if (value === 'bigger') {
        if (this.sidebarSetting === 'default') {
          this.sidebarSetting = 'max'
        }
        if (this.sidebarSetting === 'min') {
          if (this.sidebar === 'default') {
            this.sidebarSetting = 'max'
          } else {
            this.sidebarSetting = 'default'
          }
        }
      }
      if (value === 'smaller') {
        if (this.sidebarSetting === 'max') {
          this.sidebarSetting = 'default'
        } else {
          if (this.sidebarSetting === 'default') {
            this.sidebarSetting = 'min'
          }
        }
      }
    },
    jumpTo (latLng, zoom) {
      // [500, 500]
      this.jump = false
      this.$refs.map.mapObject.invalidateSize()
      if (latLng && zoom) {
        this.$refs.map.mapObject.setView(latLng, zoom)
      } else {
        this.$refs.map.mapObject.setView(latLng, 2)
      }
    },
    setHistoryDate (data) {
      let date = data.created
      this.historyDate = date
    },
    toogleHistoryMode () {
      if (this.historyMode) {
        if (this.sidebarSettingBefore) {
          this.sidebarSetting = this.sidebarSettingBefore
        }
        this.historyMode = false
        this.historyDate = false
      } else {
        this.sidebarSettingBefore = this.sidebarSetting
        this.editMarkerClose()
        this.editAreaClose()
        this.historyMode = true
      }
    },
    fullscreenToggle () {
      if (this.fullscreen) {
        this.fullscreen = false
      } else {
        this.fullscreen = true
      }
    },
    searchComplete (data) {
      this.$emit('selected', data)
    }
  },
  computed: {
    sidebar: function () {
      if ((this.markerSelected || this.areaSelected || this.historyMode) && this.sidebarSetting === 'min') return 'default'
      return this.sidebarSetting
    },
    mergedData: function () {
      var data = this.posts
      return _.orderBy(data, ['created'], ['desc'])
    },
    mergedFilteredData: function () {
      var data = _.concat(this.filteredPosts, this.filteredAreas)
      return _.orderBy(data, ['created'], ['desc'])
    },
    filteredPosts: function () {
      let dataPosts = this.posts
      var self = this // eslint-disable-line
      if (this.historyDate) {
        let date = this.historyDate
        dataPosts = _.filter(dataPosts, function (v) { return v.created <= date })
      }
      if (this.filterPriority) {
        let prio = this.filterPriority // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) { return v.priority === prio })
      }
      if (this.filterProject) {
        let project = this.filterProject // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) { return v.priority === project })
      }
      if (this.filterTag) {
        let tag = this.filterTag // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) { return v.priority === tag })
      }
      if (this.filterType) {
        let type = this.filterType // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) { return v.icon === type })
      }
      return dataPosts
    },
    filteredAreas: function () {
      let dataAreas = this.areas
      if (this.historyDate) {
        let date = this.historyDate
        dataAreas = _.filter(dataAreas, function (v) { return v.created <= date })
      }
      return dataAreas
    }
  },
  mounted () {
    this.$refs.map.mapObject.setView([500, 500], 1)
    // var bounds = new L.latLngBounds()
    // this.mapObject.fitBounds(bounds)//works!
    // this.$refs.map.mapObject.fitBounds(bounds)
    postsRef.once('value', snapshot => {
      this.dataLoaded = true
    })
  },
  firebase () {
    return {
      areas: areasRef,
      posts: postsRef,
      boards: boardsRef,
      icons: iconsRef,
      boardData: {
        source: db.ref('boards/' + this.board),
        asObject: true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.mainMap {
  height: 100vh;
  // width: 70vw;
  -webkit-user-select: none;  /* Chrome all / Safari all */
  -moz-user-select: none;     /* Firefox all */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;
  position: relative;
  z-index: 1;
}
.sidebar {
  height: 100vh;
  width: 60vw;
  text-align: left;
  background: #fff;
  position: relative;
  z-index: 2;
  box-shadow: 0 2px 24px 0 rgba(38,50,56,0.1);
  box-sizing: border-box;
  padding: relative;

  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    width: 100%;
  }

  &.sidebarFullscreen {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    z-index: 200;
  }

  transition: width 0.14s ease-in-out, transform 0.14s ease-in-out;

  .sidebarInner {
    transition: all 0.14s ease;
  }

  &.sidebarMax {
    width: 120%;
  }

  &.sidebarMin {
    // width: 350px;
    width: 0px;
    // transform: translateX(20vw);
    .sidebarToggle {
      margin-left: -50px;
      width: 50px;
      z-index: 9999;
      // background: #efefef;
      background: rgba($color-action,0.9);
      // background: rgba(255,255,255,0.9);
      button {
        // color: $color-action;
        color: #fff;
      }
      bottom: 50%;
      margin-bottom: -23px;
      &:before {
        display: none;
      }
    }
  }

  .sidebarInner {
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 46px;
    padding: 0px 30px;
  }
}

.sidebarToggle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background: rgba($color-text, 0.05);
  button {
    margin-bottom: 0;
    color: $color-action;

    &:hover {
      color: darken($color-action,7.5%);
    }
  }
  &:before {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    content: " ";
    height: 30px;
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }

  .sidebar-bigger-button {
    padding-left: 15px !important;
    float: left;
  }

  .sidebar-smaller-button {
    float: right;
    padding-right: 15px !important;
  }
}

.main {
  display: flex;
  width: calc(100% - 100px);
  position: absolute;
  left: 100px;
  top: 0;
  bottom: 0;
  right: 0;
}

.mainMap.leaflet-container {
  background-color: $background-color;
  background-color: darken($background-color,1%);
  font-family: 'Dosis', sans-serif;
}

  .mainMap .leaflet-tooltip {
    // background-color:  transparent;
    // padding-left: 10px;
    font-family: 'Dosis', sans-serif;
    border:none;
    color: $color-text;
    box-shadow:none;
    font-size: 15px;
    letter-spacing: 0.25px;
    margin-left: 12px;
    font-weight: 600;
    color: $color-action;
    border-radius: 2px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: rgba(255,255,255,0.5);
    opacity: 1 !important;
  }

  .mainMap .leaflet-marker-draggable {
    cursor: move;
  }

  .mainMap .leaflet-marker-pane svg {
    pointer-events: none;
  }

  .mainMap .leaflet-tooltip-right:before {
    display:none;
    // border-right-color: rgba(255,255,255,0.5);
  }

  .mainMap .leaflet-marker-icon text {
    text-transform: uppercase;
    letter-spacing: 1px;
    opacity: 0.35;
  }

  .tooltip--link {
    &:after {
      content: " " url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNqEkIEJwCAMBGPpEs7hHK6hY+gauoZr6Bo6RtqEWkxb6EMQnuM/USEirIoxSmOKwDkhBEwp4VPkb4801Xun9xW4e+9FldYarLUvkBPPOp4JGWOgtSaSt6VWQKUU9nPOEiSIgAmNMdadFTjn7utqrXwh6fLvH9nXhamW5ksMnpfDnw4BBgBfunO056MmqAAAAABJRU5ErkJggg==);
      margin-top: -2px;
      display: inline-block;
      margin-left: 2px;
    }
  }

  .mainMap .presenterCursor {
    background: rgba($color-error,0.8);
    color: #fff;
    margin-top: 6px;
    margin-left: 25px;
  }

  .mainMap .tooltip--selected {
    background: $color-action;
    color: #fff;
    margin-left: 12px;
    // &::before {
    //   border-right-color: $color-action;
    // }
  }

  .mainMap img.leaflet-interactive.leaflet-marker-icon {
    opacity: 0.5 !important;
    &:hover {
      opacity: 1 !important;
    }
  }

  .mainMap img.leaflet-interactive.leaflet-marker-icon.presenterIcon {
    opacity: 1 !important;
  }

  .mainMap .leaflet-control-minimap {
    box-shadow: none !important;
    border: 1px solid rgba($color-action,0.25);
  }

  .mainMap .tooltip--prio1 {
    color: $color-error;
    &.tooltip--selected {
      color: #fff;
      background: $color-error;
    }
  }

  .mainMap .tooltip--prio2 {
    color: $color-warn;
    &.tooltip--selected {
      color: #fff;
      background: $color-warn;
    }
  }

  .mainMap .tooltip--filtered {
    opacity: 0.1 !important;
    background: transparent !important;
    font-weight: 400;
    color: $color-action !important;
  }

  .leaflet-right .leaflet-control {
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .leaflet-left .leaflet-control {
    margin-left: 20px;
  }

  .leaflet-top .leaflet-control {
    margin-top: 20px;
  }

  .leaflet-control-minimap {
        // box-shadow: 0 1px 5px rgba(0,0,0,.2);
      .leaflet-interactive[stroke='#333'] {
        fill: $color-highlight !important;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/SelectionMap.vue